/**
 * AI FinOps Analytics — shared constants
 *
 * FEATURE_COLORS  : hex fill colour per feature key (used by Recharts <Bar> components)
 * FEATURE_LABELS  : human-readable display name per feature key (used by Legend + Table)
 */

export type AiFeatureKey =
    | 'spec-to-test'
    | 'auto-bug-report'
    | 'flakiness-detective'
    | 'test-optimizer'
    | 'pr-routing'
    | 'quality-chatbot'
    | 'generate-test-steps'
    | 'generate-test-suite'
    | 'automation-planner'
    | 'root-cause-analysis';

export const ALL_FEATURE_KEYS: AiFeatureKey[] = [
    'spec-to-test',
    'auto-bug-report',
    'flakiness-detective',
    'test-optimizer',
    'pr-routing',
    'quality-chatbot',
    'generate-test-steps',
    'generate-test-suite',
    'automation-planner',
    'root-cause-analysis',
];

export const FEATURE_COLORS: Record<AiFeatureKey, string> = {
    'spec-to-test':        '#8b5cf6',   // Violet
    'quality-chatbot':     '#3b82f6',   // Blue
    'auto-bug-report':     '#10b981',   // Emerald
    'flakiness-detective': '#f59e0b',   // Amber
    'test-optimizer':      '#ef4444',   // Red
    'pr-routing':          '#06b6d4',   // Cyan
    'generate-test-steps': '#a78bfa',   // Purple (lighter)
    'generate-test-suite': '#818cf8',   // Indigo
    'automation-planner':  '#f97316',   // Orange
    'root-cause-analysis': '#ec4899',   // Pink
};

export const FEATURE_LABELS: Record<AiFeatureKey, string> = {
    'spec-to-test':        'Spec-to-Test',
    'quality-chatbot':     'AI Chatbot',
    'auto-bug-report':     'Auto Bug Report',
    'flakiness-detective': 'Flakiness Detective',
    'test-optimizer':      'Test Optimizer',
    'pr-routing':          'PR Auto-Routing',
    'generate-test-steps': 'Test Step Gen',
    'generate-test-suite': 'Test Suite Gen',
    'automation-planner':  'Automation Planner',
    'root-cause-analysis': 'Root Cause Analysis',
};
